<app-alert [type]="splitState">
  <span *ngIf="splitState === alertType.Warning" class="weight-medium" title
    >{{ 'shared.warning' | translate }}
  </span>
  <span *ngIf="splitState === alertType.Success" title
    >{{ 'split.success-title' | translate }}
  </span>
  <span *ngIf="splitState === alertType.Error" title
    >{{ 'shared.operation-failed' | translate }}
  </span>

  <div *ngIf="splitState === alertType.Warning" description>
    {{ 'split.split-message' | translate }}
    <span class="weight-medium">{{ 'shared.not-undone' | translate }}</span>
  </div>
  <span *ngIf="splitState === alertType.Error" description
    >{{ 'split.fail-message' | translate }}
    {{ splitError?.errorCode === 10 ? splitError.message : ' ' }}
    {{ splitError?.errorCode === 5 ? ('errors.split' | translate) : ' ' }}
  </span>
</app-alert>

<div class="mt-2 pr-2 pl-2" *ngIf="splitState === alertType.Success">
  <div class="alert alert-success" role="alert">
    <div class="weight-medium pb-1">
      <em class="mdi mdi-ticket-confirmation has-text-grey is-size-6"></em>
      {{ 'split.new-pnr' | translate }}
    </div>
    <div class="is-size-6">• {{ newPnr }}</div>
  </div>
</div>

<div class="mt-2 p-2">
  <app-passengers-resume [passengers]="selectedPassengers"> </app-passengers-resume>
</div>

<div class="button-container" *ngIf="splitState !== alertType.Success">
  <app-input-submit
    inputText="{{ 'voluntary-change.divide' | translate }}"
    type="submit"
    (clickButton)="splitPNR()"
  ></app-input-submit>
</div>

<div class="button-container" *ngIf="splitState === alertType.Success">
  <div class="column">
    <app-input-submit
      class="is-pulled-right"
      [isLeft]="true"
      inputText="{{ 'shared.continue' | translate }}"
      type="submit"
      (clickButton)="splitPNRSuccess()"
    ></app-input-submit>
  </div>
</div>
